import { registerAction } from '../../Action'

const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ'

const reducer = (state = {}, action) => {
  const itemData = state.notifications.find(
    (item) => item.id === action.payload
  )
  const itemIndex = state.notifications.indexOf(itemData)
  if (itemIndex > -1) {
    return {
      ...state,
      notifications: [
        state.notifications.splice(itemIndex, 1, { ...itemData, read: true }),
      ],
    }
  }
  return state
}

const markNotificationRead = registerAction(MARK_NOTIFICATION_READ, { reducer })

export default markNotificationRead
